import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

export const useDayjs = () => {
  const formatTime = (millis?: number) => {
    return typeof millis === 'undefined' ? '--:--' : dayjs.duration(millis).format(import.meta.env.VITE_TIME_FORMAT)
  }

  return { formatTime }
}
